import styled from 'styled-components/macro'

import {
  FONT_WEIGHTS,
  getMarginBottom,
  getMarginTop,
  TMargin,
} from '../../../designSystem'

type TProps = {
  marginTop?: TMargin
  marginBottom?: TMargin
}

/**
 * H2 used for section headlines.
 */
export const SectionHeadline = styled.h2<TProps>`
  font-size: 1.25rem;
  line-height: 1.2;
  font-weight: ${FONT_WEIGHTS.boldSemi};

  margin-top: ${({ marginTop = 's0' }) => getMarginTop({ marginTop })};
  margin-bottom: ${({ marginBottom = 's8' }) =>
    getMarginBottom({ marginBottom })};
`
